import { ReactNode } from "react"

import { Icon } from "@tabler/icons-react"

import { cn } from "@/lib/utils"

export interface EmptyStateProps {
  title: string | ReactNode
  subTitle?: string
  icon?: Icon
  actions?: ReactNode
  className?: string
}

export function EmptyState({
  icon,
  title,
  subTitle,
  actions,
  className,
}: EmptyStateProps) {
  const IconComponent = icon

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-6 rounded-md border border-solid border-border bg-grey-100 p-5",
        className,
      )}
    >
      {IconComponent != null && (
        <div className="mb-1 rounded-full bg-muted p-3">
          <IconComponent size={24} />
        </div>
      )}
      <div className="flex flex-col items-center gap-2">
        <div className="text-body1 font-medium text-grey-800">{title}</div>
        {subTitle ? (
          <div className="text-center text-body1 whitespace-pre-line text-grey-700">
            {subTitle}
          </div>
        ) : null}
      </div>
      {actions}
    </div>
  )
}
